import 'font-awesome-webpack';
import 'react-select/dist/react-select.css';
import 'react-toastify/dist/ReactToastify.css';
import 'classlist-polyfill';
import 'react-datepicker/dist/react-datepicker.css';
import './less/index.less';



// WEBPACK FOOTER //
// ./src/styles.js